import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCarAlt, FaTruck, FaBoxes, FaExchangeAlt, FaQuestionCircle, FaStackExchange, FaGlobeAfrica, FaCreditCard, FaTimes } from 'react-icons/fa';
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from '../../composant_reutilisable/navbar';
import useAuth from '../../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from '../../composant_reutilisable/pas_acces';
import axios from 'axios';
import Footer from '../../composant_reutilisable/footer';
import { Modal } from 'react-bootstrap';
import { FaMoneyBillTransfer } from 'react-icons/fa6';

const Gie_parcs = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];

    const [userData, setUserData] = useState({});
    const [parcs, setParcs] = useState([]);
    const [showGlossary, setShowGlossary] = useState(false);
    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);

    // États pour le modal
    const [showModal, setShowModal] = useState(false);
    const [selectedParc, setSelectedParc] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`
                );
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);

    const fetchParcs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setParcs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Parcs GIE";
        }
        fetchParcs();
    }, [user_id]);


    const handleParcClick = (parc) => {
        navigate('/Factures-GIE', {
            state: {
                parcId: parc.id,
                parcRef: parc.ref_parc
            }
        });
    };

    const userHasAccess = (accessKey) => {
        return accesGroupe.includes(accessKey);
    };

    const isAdminUser = () => {
        return accesGroupes.includes("Administration");
    };


    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const groupe = localStorage.getItem('groupe_id');
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);



    if (
        !accesGroupes.includes("Fret") &&
        !accesGroupes.includes("Mise_en_file")
    ) {
        return <Pas_acces />;
    }

    // Fonction pour obtenir l'icône en fonction du type de parc
    const getParcIcon = (typeParc) => {
        switch (typeParc) {
            case 'national':
                return <FaTruck className="text-primary" />;
            case 'international':
                return <FaGlobeAfrica className="text-success" />;
            default:
                return <FaCarAlt className="text-secondary" />;
        }
    };

    // Fonction pour obtenir la classe CSS en fonction du type de parc
    const getParcCardClass = (typeParc) => {
        switch (typeParc) {
            case 'national':
                return 'border-primary';
            case 'international':
                return 'border-success';
            default:
                return 'border-secondary';
        }
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaMoneyBillTransfer size={25} className='mr-2' /> Groupement d'Intérêt Economique
                                </div>
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Groupement d'Intérêt Economique</li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight p-5">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>Sélection du parc</h5>
                        </div>
                        {userData?.parc === "Non affecté" && !isAdminUser() ? (
                            // 🚫 Cas 1 : utilisateur sans parc et non admin
                            <div className="alert alert-warning mx-auto" style={{ maxWidth: "600px" }}>
                                <h4 className="text-danger">Aucun parc assigné</h4>
                                <p>
                                    Vous n’avez pas encore été affecté à un parc.<br />
                                    Veuillez contacter un administrateur pour obtenir une affectation.
                                </p>
                                <button
                                    className="btn btn-primary mt-3"
                                    onClick={() => navigate("/Menu")}
                                >
                                    Retour à l’accueil
                                </button>
                            </div>
                        ) : (
                            // ✅ Cas 2 : utilisateur admin ou affecté à un parc
                            <div className="row mx-auto justify-content-center">
                                {parcs.map((parc) => (
                                    <div key={parc.id} className="col-md-3 col-sm-6 mb-4">
                                        <div
                                            className={`card rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center ${getParcCardClass(parc.type_parc)}`}
                                            onClick={() => handleParcClick(parc)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s',
                                                border: '2px solid'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body text-center">
                                                <div className="mb-3 icon-large">
                                                    {getParcIcon(parc.type_parc)}
                                                </div>
                                                <h5 className="card-title">{parc.nom_parc}</h5>
                                                {/* <p className="card-text mb-1">
                                                    <small className="text-muted">
                                                        Type: {parc.type_parc === 'national' ? 'National' : 'International'}
                                                    </small>
                                                </p> */}
                                                {parc.pays_parc && (
                                                    <p className="card-text mb-1">
                                                        <small className="text-muted">
                                                            Pays: {parc.pays_parc}
                                                        </small>
                                                    </p>
                                                )}
                                                {parc.ref_parc && (
                                                    <p className="card-text">
                                                        <small className="text-muted">
                                                            Référence: {parc.ref_parc}
                                                        </small>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {parcs.length === 0 && (
                            <div className="text-center mt-5">
                                <div className="spinner-border text-primary" role="status">
                                </div>
                                <p className="mt-3">Chargement des parcs...</p>
                            </div>
                        )}
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Gie_parcs;